module.exports = __webpack_public_path__ + "static/media/whiteWaglLogo.13b740c6.svg";